import config_development from "./config-development";
import config_test from "./config-test";
import config_production from "./config-production";
import config_sisprod from "./config-sisprod";

export default class Config {
  constructor(env) {
    this.env = env;
  }

  getConfig() {
    switch (this.env) {
      case "sisprod":
        return config_sisprod;
      case "tests":
        return config_test;
      case "production":
        return config_production;
      default:
        return config_development;
    }
  }
}
